"use client";
import useEmblaCarousel from "embla-carousel-react";
import Link from "next/link";
import IMAGES from "@/data/assetData";
import Image from "next/image";
import { sanitizeLegalContent } from "@/utils/sanitizeRentalContent";

const FeaturesCarousels = ({ legalData }) => {
  // sanitizeLegalContent, not sanitizeRentalContent: this template renders no
  // H1 of its own, so the rental sanitiser's blanket H1->H2 demotion left all
  // four /legal/* pages with zero H1s. No `h1` anchor is passed for the same
  // reason — there is no chrome H1 for body headings to be deduped against.
  const sanitizedLegalContent = sanitizeLegalContent(legalData?.shortContent);
  const [emblaRef] = useEmblaCarousel({
    loop: true,
    align: "start",
    slidesToScroll: 1,
  });

  const data = [
    { id: 1, IMAGES: "frame3", name: "Terms & Condition", url: "legal/terms-of-use" },
    { id: 2, IMAGES: "frame3", name: "Cancellation & Refund Policy", url: "legal/refund-cancellation-policy" },
    { id: 3, IMAGES: "frame3", name: "Privacy Policy", url: "legal/privacy-policy" },
    { id: 4, IMAGES: "frame3", name: "Copyright Policy", url: "legal/copyright-policy" },
  ];

  return (
    <div>
      <div className="slider">
        <div className="mt-[10px] mb-[30px] mx-[8%]">
          <div className="contact-carousel">
            <div className="overflow-hidden" ref={emblaRef}>
              <div className="flex gap-2.5 items-center">
                {data.map((item) => (
                  <Link
                    key={item.id}
                    href={`/${item.url}/`}
                    className={`carousel-image-container relative pb-[60px] mb-0 border rounded-lg min-w-0 flex-[0_0_calc(50%-5px)] min-[600px]:flex-[0_0_calc(33.33%-7px)] lg:flex-[0_0_calc(25%-7.5px)] focus-visible:outline-none ${legalData?.url === item.url ? "!border-primary !border-2" : ""}`}
                  >
                    <Image
                      className="mx-auto h-20 w-20 p-2.5"
                      src={IMAGES[item.IMAGES]}
                      alt={item.name}
                      width={120}
                      height={120}
                    />
                    <p className="font-normal text-center leading-[21px] absolute w-full h-auto bottom-0 px-0.5 py-2.5 text-sm">
                      {item.name}
                    </p>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-[5%]">
        {sanitizedLegalContent ? (
          <div
            className="legal-content dynamic-code-content"
            dangerouslySetInnerHTML={{ __html: sanitizedLegalContent }}
          />
        ) : (
          <p>Loading content...</p>
        )}
      </div>
    </div>
  );
};

export default FeaturesCarousels;
